<template>
  <div style="width:100%;height:100%;box-sizing:border-box;background-color:#f5f7fa;display:flex;flex-direction:column">
    <!-- 自定义 Tab 头 -->
    <div class="spb-tab-header">
      <div :class="['spb-tab-item', activeTab === 'kanban' ? 'spb-tab-active' : '']" @click="switchTab('kanban')">
        <i class="el-icon-data-analysis"></i>
        <span>服务项目包看板</span>
      </div>
      <div :class="['spb-tab-item', activeTab === 'list' ? 'spb-tab-active' : '']" @click="switchTab('list')">
        <i class="el-icon-s-order"></i>
        <span>服务项目包管理</span>
      </div>
    </div>

    <!-- 看板 -->
    <div v-show="activeTab === 'kanban'" class="spb-tab-content">
      <div class="spb-search-bar">
        <el-input v-model="kanbanSearchName" placeholder="项目包名称搜索" clearable prefix-icon="el-icon-search"
                  style="width:200px" @keyup.enter.native="searchKanban"></el-input>
        <el-cascader v-fixZoom v-model="kanbanSearchOid" :options="orgTree" :props="orgCascaderProps"
                     filterable clearable placeholder="组织筛选" style="width:200px;margin-left:10px"></el-cascader>
        <el-button type="primary" icon="el-icon-search" @click="searchKanban" style="margin-left:10px">查询</el-button>
      </div>
      <div class="spb-summary-cards">
        <div class="spb-card spb-card-blue">
          <div class="spb-card-num">{{ kanbanTotal }}</div>
          <div class="spb-card-label">项目包总数</div>
        </div>
        <div class="spb-card spb-card-green">
          <div class="spb-card-num">{{ kanbanSummary.completed }}</div>
          <div class="spb-card-label">已完成</div>
        </div>
        <div class="spb-card spb-card-orange">
          <div class="spb-card-num">{{ kanbanSummary.inprogress }}</div>
          <div class="spb-card-label">进行中</div>
        </div>
        <div class="spb-card spb-card-gray">
          <div class="spb-card-num">{{ kanbanSummary.closed }}</div>
          <div class="spb-card-label">已关闭</div>
        </div>
      </div>
      <div class="spb-table-wrap">
        <el-table v-loading="kanbanLoading" element-loading-text="加载中，请耐心等待。"
                  :data="kanbanData" border style="width:100%" highlight-current-row
                  :header-cell-style="{background:'#f0f4ff',color:'#333',fontWeight:'bold'}">
          <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
          <el-table-column label="项目包名称" min-width="150" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#409EFF;font-weight:500">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属组织" min-width="110" align="center" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.org_name }}</span></template>
          </el-table-column>
          <el-table-column label="服务内容" min-width="140" align="center" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.supplier_type_name }}</span></template>
          </el-table-column>
          <el-table-column label="服务次数" width="85" align="center">
            <template slot-scope="scope">
              <el-tag type="info" size="mini">{{ scope.row.target_count }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="有效期" min-width="195" align="center">
            <template slot-scope="scope">
              <i class="el-icon-date" style="color:#909399;margin-right:4px"></i>
              <span>{{ scope.row.valid_start_date }} ~ {{ scope.row.valid_end_date }}</span>
            </template>
          </el-table-column>
          <el-table-column label="已完成" width="75" align="center">
            <template slot-scope="scope">
              <el-tag type="success" size="mini">{{ scope.row.completed_count }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="进行中" width="75" align="center">
            <template slot-scope="scope">
              <el-tag type="primary" size="mini">{{ scope.row.inprogress_count }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="已关闭" width="75" align="center">
            <template slot-scope="scope">
              <el-tag type="info" size="mini">{{ scope.row.closed_count }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="完成率" width="90" align="center">
            <template slot-scope="scope">
              <span :style="{color: parseRate(scope.row.completion_rate) >= 80 ? '#67C23A' : parseRate(scope.row.completion_rate) >= 50 ? '#E6A23C' : '#F56C6C', fontWeight:'bold'}">
                {{ scope.row.completion_rate }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="148" align="center">
            <template slot-scope="scope"><span>{{ scope.row.create_tm }}</span></template>
          </el-table-column>
        </el-table>
      </div>
      <div class="spb-pagination">
        <el-pagination @size-change="kanbanSizeChange" @current-change="kanbanPageChange"
                       :current-page="kanbanPage" :page-sizes="[10,20,50,100]"
                       :page-size="kanbanSize" layout="total, sizes, prev, pager, next, jumper"
                       :total="kanbanTotal">
        </el-pagination>
      </div>
    </div>

    <!-- 列表管理 -->
    <div v-show="activeTab === 'list'" class="spb-tab-content">
      <div class="spb-search-bar">
        <el-input v-model="searchName" placeholder="项目包名称搜索" clearable prefix-icon="el-icon-search"
                  style="width:200px" @keyup.enter.native="searchQuery"></el-input>
        <el-cascader v-fixZoom v-model="searchOid" :options="orgTree" :props="orgCascaderProps"
                     filterable clearable placeholder="组织筛选" style="width:200px;margin-left:10px"></el-cascader>
        <el-button type="primary" icon="el-icon-search" @click="searchQuery" style="margin-left:10px">查询</el-button>
        <el-button type="success" icon="el-icon-plus" @click="addBundle" style="margin-left:10px">新建服务项目包</el-button>
      </div>
      <div class="spb-table-wrap">
        <el-table v-loading="listLoading" element-loading-text="加载中，请耐心等待。"
                  :data="tableData" border style="width:100%" highlight-current-row ref="listTable"
                  :header-cell-style="{background:'#f0f4ff',color:'#333',fontWeight:'bold'}">
          <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
          <el-table-column label="项目包名称" min-width="150" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#409EFF;font-weight:500">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属组织" min-width="110" align="center" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ getOrgName(scope.row.oid) }}</span></template>
          </el-table-column>
          <el-table-column label="服务内容" min-width="140" align="center" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.supplier_type_name || getServiceName(scope.row.ss_id) }}</span></template>
          </el-table-column>
          <el-table-column label="服务次数" width="85" align="center">
            <template slot-scope="scope">
              <el-tag type="info" size="mini">{{ scope.row.target_count }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="有效期" min-width="195" align="center">
            <template slot-scope="scope">
              <i class="el-icon-date" style="color:#909399;margin-right:4px"></i>
              <span>{{ scope.row.valid_start_date }} ~ {{ scope.row.valid_end_date }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="110" align="center" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.remark }}</span></template>
          </el-table-column>
          <el-table-column prop="create_tm" label="创建时间" min-width="148" align="center"></el-table-column>
          <el-table-column align="center" label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="editBundle(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="deleteBundle(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="spb-pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10,20,50,100]"
                       :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                       :total="totalCells">
        </el-pagination>
      </div>
    </div>

    <!-- 新建/编辑弹窗 -->
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="680px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><strong>{{ addEditTitle }}</strong></div>
        <div class="line-title"></div>
      </div>
      <add-edit-bundle :addEdit="addEditObj" :org-tree="orgTree" v-model="addEditShow" @refresh="onRefreshAfterEdit"></add-edit-bundle>
    </el-dialog>
  </div>
</template>

<script>
import { queryorg } from '../../api/organizer'
import {
  querysuppliertype,
  queryserviceprojectbundle,
  deleteserviceprojectbundle,
  queryserviceprojectbundlekanban
} from '../../api/serviceMark'
import addEditBundle from './childComponents/addEditServiceProjectBundle.vue'

export default {
  name: 'serviceProjectBundle',
  components: { addEditBundle },
  data () {
    return {
      activeTab: 'kanban',
      orgTree: [],
      orgFlatData: [],
      serviceTypeFlat: [], // 服务类型平铺，用于 ID→名称反查
      orgCascaderProps: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'child',
        emitPath: false
      },
      kanbanLoading: false,
      kanbanSearchName: '',
      kanbanSearchOid: null,
      kanbanPage: 1,
      kanbanSize: 20,
      kanbanTotal: 0,
      kanbanData: [],
      kanbanSummary: { completed: 0, inprogress: 0, closed: 0 },
      listLoading: false,
      searchName: '',
      searchOid: null,
      currentPage: 1,
      pageSize: 10,
      totalCells: 0,
      tableData: [],
      addEditShow: false,
      addEditTitle: '新建服务项目包',
      addEditObj: { isAdd: true, row: {} }
    }
  },
  created () {
    this.loadOrg()
    this.loadServiceTypes()
    this.loadKanban()
  },
  methods: {
    loadServiceTypes () {
      querysuppliertype({ page: 1, size: 99999 }, { orgid: [] }).then(res => {
        this.serviceTypeFlat = res.data.types || []
      }).catch(() => {})
    },
    getServiceName (ssId) {
      if (!ssId) return ''
      const node = this.serviceTypeFlat.find(o => o.id === ssId)
      return node ? node.typename : ssId
    },
    loadOrg () {
      queryorg().then(res => {
        const arr = (res.data.org || []).filter(o => o.org_type === 0)
        this.orgFlatData = arr
        let minLevel = arr.reduce((min, o) => Math.min(min, o.level), 100)
        let roots = arr.filter(o => o.level === minLevel)
        roots.forEach(root => {
          const children = this.buildOrgTree(arr, root.id)
          if (children.length) root.child = children
        })
        this.orgTree = roots
      }).catch(() => {})
    },
    buildOrgTree (arr, pid) {
      return arr.filter(o => o.orgpid === pid).map(o => {
        const children = this.buildOrgTree(arr, o.id)
        if (children.length) o.child = children
        return o
      })
    },
    switchTab (name) {
      this.activeTab = name
      if (name === 'list' && this.tableData.length === 0) {
        this.loadTableData()
      }
    },
    loadKanban () {
      this.kanbanLoading = true
      const params = { page: this.kanbanPage, size: this.kanbanSize }
      const data = { oid: this.kanbanSearchOid || 0, name: this.kanbanSearchName }
      queryserviceprojectbundlekanban(params, data).then(res => {
        this.kanbanData = res.data.list || []
        this.kanbanTotal = res.data.cnt || 0
        let completed = 0; let inprogress = 0; let closed = 0
        this.kanbanData.forEach(r => {
          completed += r.completed_count || 0
          inprogress += r.inprogress_count || 0
          closed += r.closed_count || 0
        })
        this.kanbanSummary = { completed, inprogress, closed }
        this.kanbanLoading = false
      }).catch(() => { this.kanbanLoading = false })
    },
    searchKanban () { this.kanbanPage = 1; this.loadKanban() },
    resetKanban () { this.kanbanSearchName = ''; this.kanbanSearchOid = null; this.searchKanban() },
    kanbanSizeChange (val) { this.kanbanSize = val; this.loadKanban() },
    kanbanPageChange (val) { this.kanbanPage = val; this.loadKanban() },
    parseRate (rateStr) { return parseFloat(rateStr) || 0 },
    loadTableData () {
      this.listLoading = true
      const params = { page: this.currentPage, size: this.pageSize }
      const data = { oid: this.searchOid || 0, name: this.searchName }
      queryserviceprojectbundle(params, data).then(res => {
        this.tableData = res.data.list || []
        this.totalCells = res.data.cnt || 0
        this.listLoading = false
      }).catch(() => { this.listLoading = false })
    },
    searchQuery () { this.currentPage = 1; this.loadTableData() },
    resetList () { this.searchName = ''; this.searchOid = null; this.searchQuery() },
    handleSizeChange (val) { this.pageSize = val; this.loadTableData() },
    handleCurrentChange (val) { this.currentPage = val; this.loadTableData() },
    getOrgName (oid) {
      const org = this.orgFlatData.find(o => o.id === oid)
      return org ? org.name : (oid || '')
    },
    onRefreshAfterEdit () { this.loadTableData(); this.loadKanban() },
    addBundle () {
      this.addEditTitle = '新建服务项目包'
      this.addEditObj = { isAdd: true, row: {} }
      this.addEditShow = true
    },
    editBundle (row) {
      this.addEditTitle = '编辑服务项目包'
      this.addEditObj = { isAdd: false, row: row }
      this.addEditShow = true
    },
    deleteBundle (row) {
      this.$confirm(`此操作将删除服务项目包【${row.name}】，是否继续?`, '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        deleteserviceprojectbundle({ id: row.id }).then(() => {
          this.$notify({ title: '成功', message: '删除服务项目包成功', type: 'success', duration: 2000 })
          if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage--
          this.loadTableData()
          this.loadKanban()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.spb-tab-header {
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 2px solid #e4e7ed;
  padding: 0 20px;
  flex-shrink: 0;
}
.spb-tab-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 14px 24px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s;
}
.spb-tab-item:hover { color: #409EFF; }
.spb-tab-active { color: #409EFF !important; border-bottom-color: #409EFF !important; font-weight: 600; }
.spb-tab-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px 20px 10px;
  overflow: hidden;
}
.spb-search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 14px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  flex-shrink: 0;
}
.spb-summary-cards { display: flex; gap: 14px; margin-bottom: 14px; flex-shrink: 0; }
.spb-card {
  flex: 1;
  border-radius: 8px;
  padding: 16px 20px;
  text-align: center;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.spb-card-num { font-size: 28px; font-weight: bold; line-height: 1.2; }
.spb-card-label { font-size: 13px; margin-top: 6px; opacity: 0.9; }
.spb-card-blue   { background: linear-gradient(135deg, #409EFF, #66b1ff); }
.spb-card-green  { background: linear-gradient(135deg, #67C23A, #85ce61); }
.spb-card-orange { background: linear-gradient(135deg, #E6A23C, #ebb563); }
.spb-card-gray   { background: linear-gradient(135deg, #909399, #a6a9ad); }
.spb-table-wrap {
  flex: 1;
  overflow: auto;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.spb-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 6px;
  margin-top: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/serviceProjectBundle.vue